import { Container, Row, Col } from 'react-bootstrap';
import { MyClients } from '../../components';

const Clients = () => {
    return (
        <Container fluid className="clients-page">
            <Row>
                <Col>
                    <h1 className="display-1">Clients</h1>
                    <div className="display-2">Manage and Track Your Clients</div>
                </Col>
            </Row>
            <Row className="mt-0 gy-4">
                <Col lg={12}>
                    <MyClients />
                </Col>
            </Row>
        </Container>  
    );
};

export default Clients;